import { render, staticRenderFns } from "./ConfirmUpdatePassword.vue?vue&type=template&id=5b419698&"
import script from "./ConfirmUpdatePassword.vue?vue&type=script&lang=js&"
export * from "./ConfirmUpdatePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports